import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { AuthLayout, styles } from './authStyles';

const RemindPasswordConfirmation = ({ classes, className }) => (
  <AuthLayout>
    <Typography color="primary" variant="h6" gutterBottom>
      An email has been sent
    </Typography>
    <Typography variant="body2">
      An email has been sent. It contains a link you must click to reset your password.<br/>
      Note: you can only request a new password once within 2 hours.<br/>
      <br/>
      If you don't get an email, check your spam folder or try again.<br/>
    </Typography>

    <div className={classes.avatar}>
      <Button component={Link} to="/login">
        Log in
      </Button>
    </div>
  </AuthLayout>
);

export default withStyles(styles)(RemindPasswordConfirmation);
